<template>
    <section class="side-menu-container">
        <section class="side-menu-title">
            <button type="button" @click="$router.push({ name: 'news.list' })">
                <i class="fal fa-comment-alt-smile" />
            </button>
            <h3>Comunicação</h3>
        </section>
        <section class="side-menu">
            <router-link :to="{ name: 'news.add' }">
                <span>Criar Novidades</span>
                <span><i class="fal fa-chevron-right" /></span>
            </router-link>
            <a v-if="hasEvent" @click="redirectionCreateEvent">
                <span>Criar Evento</span>
                <span><i class="fal fa-chevron-right" /></span>
            </a>
        </section>
    </section>
</template>

<script>
    import { storage } from '@/services/storage'
    import { configuration }   from "@/services/axios"
	import helpers from '@/mixins/helpers'
	export default {
		name: 'side-menu',

		mixins: [ helpers ],
        computed: {
            hasEvent() {
                let config = JSON.parse(storage.get('get-configs-data'))
                if(config) {
                    return config.menuAllowed.includes('agenda')
                }
                return false
            }
        },

        methods: {
            redirectionCreateEvent() {
                window.location.assign(this.oldPanelLink('eventos/adicionar'))
            }
        }

	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl';
</style>
